export default String.raw`
.comparison {
    width: 100%;

    &__wrapper {
        padding: 0;
    }

    &__header {
        padding: 0 16px 20px 16px;
    }

    .swiper {
        overflow: hidden !important;
    }

    .gradient,
    .full-row__empty,
    .top-info .comparer__table-attribute-name {
        display: none !important;
    }

    .top-info .table__row {
        display: flex;
    }

    .table {
        &__row {
            display: block;

            &-cell {
                flex: 1 0 50%;
            }
        }
    }
}



.comparer {
    &__sticky-header {
        padding: 0;
    }

    &__table-attribute-name {
        align-items: center;
        font-weight: 500;
    }

    &__slider-button-prev,
    &__slider-button-next {
        display: none;
    }
}

.product-card {
    &__prices {
        gap: 4px;
    }

    &__info-group {
        gap: 4px;
    }

    &__price-tax {
        @include body-2-regular;
    }

    .label {
        gap: 8px;
    }

    .button {
        &__group {
            .button__text {
                display: none;
            }
        }
    }
}

//Exception:

.button[aria-label="notify-about-availability"] .button__text {
    max-width: unset;
}

`